import { Injectable } from '@angular/core';
import { LazyLoadingService } from './lazy-loading.service';
import { MessageAmplifyInit, MessageCheckTokenHasExpired, MessageService, MessageTokenHasExpired } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class AmplifyControllerService {
  private Auth;
  private API;
  private Storage;
  private Signer;
  private urlLib;

  constructor(private lazyLoadingService: LazyLoadingService,
    private messageService: MessageService) {
    this.Auth = null;
    this.API = null;
    this.Storage = null;
    this.Signer = null;
    this.urlLib = null;
  }

  public setAuth(amplifyAuth) {
    this.Auth = amplifyAuth;
  }

  public setApi(amplifyApi) {
    console.log('setApi')
    this.API = amplifyApi;
  }

  public setStorage(amplifyStorage) {
    this.Storage = amplifyStorage;
  }

  public setSigner(amplifySigner) {
    this.Signer = amplifySigner;
  }

  public setUrlLib(urlLib) {
    this.urlLib = urlLib;
  }

  getCurrentCredentials() {
    return this.getAuth()
      .then(Auth => {
        return Auth.currentCredentials()
      })
      .then(credentials => {
        if (credentials.expired) {
          console.log('credentials expired');
          credentials.refresh((err) => {
            if (err) {
              console.log('credentials refresh error: ', err);
              throw new Error('ERR_REFRESH_FAILED')
            } else {
              console.log('TOKEN SUCCESSFULLY UPDATED');
              return this.Auth.currentCredentials();
            }
          });
        } else if (credentials.statusCode === 400 && credentials.code === 'NotAuthorizedException') {
          console.log('access forbidden');
          const idToken = localStorage.getItem('CognitoIdentityId-us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0');
          if (idToken) {
            localStorage.removeItem('CognitoIdentityId-us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0');
          }
          return this.Auth.currentCredentials();
        }
        else {
          console.log('credentials active', credentials);
          return Promise.resolve(credentials);
        }
      })
      .catch(err => {
        if (typeof err === 'object' && err.toString() && err.toString().includes('forbidden')) {
          console.log('access forbidden');
          const idToken = localStorage.getItem('CognitoIdentityId-us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0');
          if (idToken) {
            localStorage.removeItem('CognitoIdentityId-us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0');
          }
          return this.Auth.currentCredentials();
        } else {
          throw new Error('ERR_UNKNOWN')
        }
      });

  }

  // private importAmplifyModule() {
  //   return import('../modules/lazy-loaded/amplify/amplify.module')
  //   .then(m => m.AmplifyModule)
  //   .catch(err => {
  //     console.log('getAuth import err ', err);
  //     return Promise.resolve(null);
  //   })
  // }

  // public getAuth2() {
  //   console.log('getAuth')
  //   return this.importAmplifyModule()
  //     .then(amplifyModule => {
  //       return this.lazyLoadingService.createLazyModule(amplifyModule)
  //     })
  //     .then(res => {
  //       console.log('getAuth res ', res)
  //       if (this.Auth)
  //         return this.Auth;
  //     })
  //     .catch(err =>{
  //       console.log('getAuth err ', err);
  //     })
  // }
  public init() {
    return this.lazyLoadingService.loadAmplifyModule()
      .then(res => {
        this.messageService.sendMessage({ name: MessageAmplifyInit });
        console.log('getAuth res ', res)
      })
      .catch(err =>{
        console.log('getAuth err ', err);
      })
  }

  public getAuth() {
    console.log('getAuth')
    // return this.lazyLoadingService.createLazyModule(() =>
    //   import('../modules/lazy-loaded/amplify/amplify.module')
    //     .then(m => m.AmplifyModule)
    //     .catch(err => {
    //       console.log('getAuth import err ', err);
    //     })
    //   )
    return this.lazyLoadingService.loadAmplifyModule()
      .then(res => {
        console.log('getAuth res ', res)
        if (this.Auth)
          return this.Auth;
      })
      .catch(err =>{
        console.log('getAuth err ', err);
      })
  }

  public getAPI() {
    // return this.lazyLoadingService.createLazyModule(() =>
    //   import('../modules/lazy-loaded/amplify/amplify.module')
    //     .then(m => m.AmplifyModule)
    //     .catch(err => {
    //       console.log('getAuth import err ', err);
    //     })
    //   )
    return this.lazyLoadingService.loadAmplifyModule()
      .then(_ => {
        // console.log('this.API: ', this.API);
        if (this.API)
          return this.API;
      })
  }

  public getStorage(bucketName) {
    return this.lazyLoadingService.loadAmplifyModule()
      .then(_ => {
        if (this.Storage) {
          this.Storage.configure({
            AWSS3: {
              bucket: bucketName,
              region: 'us-east-1',
              // identityPoolId: 'us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0'
            }
          });
          return this.Storage;
        }
      })
  }

  public getSigner() {
    // return this.lazyLoadingService.createLazyModule(() =>
    //   import('../modules/lazy-loaded/amplify/amplify.module')
    //     .then(m => m.AmplifyModule)
    //     .catch(err => {
    //       console.log('getAuth import err ', err);
    //     })
    //   )
    return this.lazyLoadingService.loadAmplifyModule()
      .then(_ => {
        if (this.Signer)
          return this.Signer;
      })
  }

  public getUrlLib() {
    // return this.lazyLoadingService.createLazyModule(() =>
    //   import('../modules/lazy-loaded/amplify/amplify.module')
    //     .then(m => m.AmplifyModule)
    //     .catch(err => {
    //       console.log('getAuth import err ', err);
    //     })
    //   )
    return this.lazyLoadingService.loadAmplifyModule()
      .then(_ => {
        if (this.urlLib)
          return this.urlLib;
      })
  }

  public async getSession(): Promise<any> {
    try {
      const auth = await this.getAuth();
      const userSession = await auth.currentSession();
      return userSession;
    } catch (err) {
      console.error('Session error:', err);
      // if ((err.message && err.message.includes('Refresh Token has expired')) || (err.code && err.code === 'NotAuthorizedException')) {
      //   await this.handleSessionExpired();
      // }
      if (err.message && err.message.includes('NetworkError')) {
        return null; 
      } else {
        this.messageService.sendMessage({ name: MessageCheckTokenHasExpired });
        return null; // or return Promise.reject(err);  
      }
    }
  }

  // private async handleSessionExpired() {
  //   console.log('Session expired. Logging out and reloading the page...');
  //   // this.messageService.sendMessage({ name: MessageTokenHasExpired });

  //   // try {
  //   //   await Auth.signOut();
  //   // } catch (signOutErr) {
  //   //   console.error('Failed to sign out:', signOutErr);
  //   // } finally {
  //   //   window.location.reload();
  //   // }
  // }
}
